import React, { useContext } from 'react'
import { hot } from 'react-hot-loader'
import PropTypes from 'prop-types'
import { LocalisationProvider } from '@yoti-web-share/localisation'
import { ShareFlowProvider } from '@yoti-web-share/share-flow'
import { IframeClientProvider } from '@yoti-web-share/iframe-client'
import { SkinContext, SkinProvider, SkinsIdentifiers } from '@yoti-web-share/skins'
import WebShare from '../WebShare'


const skinIdToLocaleMap = {
  [SkinsIdentifiers.POST_OFFICE]: 'en_post-office',
  [SkinsIdentifiers.YOTI_WITH_POST_OFFICE]: 'en_yoti-with-post-office',
  [SkinsIdentifiers.DIDC]: 'en_didc'
}

const WithSkinLocalisationProvider = ({ children }) => {
  const { id: skinId } = useContext(SkinContext)
  return (
    <LocalisationProvider locale={skinIdToLocaleMap[skinId]}>
      {children}
    </LocalisationProvider>
  )
}

WithSkinLocalisationProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.node
  ]).isRequired
}

const App = () => (
  <SkinProvider>
    <WithSkinLocalisationProvider>
      <IframeClientProvider name="inline">
        <ShareFlowProvider>
          <WebShare />
        </ShareFlowProvider>
      </IframeClientProvider>
    </WithSkinLocalisationProvider>
  </SkinProvider>
)

export default hot(module)(App)
